export default __webpack_public_path__ + "static/media/captcha.8daac83a.png";